/* Reyform: menu, pop-up, FAQ, scroll-reveal en het offerteformulier. */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* mobiel menu */
  var toggle = document.querySelector("[data-menu-toggle]");
  var menu = document.getElementById("mobielmenu");
  if (toggle && menu) {
    toggle.addEventListener("click", function () {
      var open = menu.hasAttribute("hidden");
      if (open) menu.removeAttribute("hidden"); else menu.setAttribute("hidden", "");
      toggle.setAttribute("aria-expanded", String(open));
      toggle.setAttribute("aria-label", open ? "Menu sluiten" : "Menu openen");
    });
    menu.addEventListener("click", function (e) {
      if (e.target.tagName === "A") toggle.click();
    });
  }

  /* offerte pop-up */
  var modal = document.querySelector("[data-quote-modal]");
  var lastFocus = null;
  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.removeAttribute("hidden");
    document.body.classList.add("rf-locked");
    var first = modal.querySelector(".rf-chip, button, input");
    if (first) first.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.setAttribute("hidden", "");
    document.body.classList.remove("rf-locked");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-quote-open]")) { e.preventDefault(); openModal(); }
    else if (e.target.closest("[data-quote-close]")) closeModal();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (modal && !modal.hasAttribute("hidden")) closeModal();
    else if (menu && !menu.hasAttribute("hidden") && toggle) toggle.click();
  });

  /* FAQ: maximaal één open */
  document.querySelectorAll("[data-faq]").forEach(function (group) {
    var items = group.querySelectorAll(".rf-faq__item");
    items.forEach(function (item) {
      var btn = item.querySelector(".rf-faq__q");
      if (!btn) return;
      btn.addEventListener("click", function () {
        var open = item.getAttribute("data-open") === "true";
        items.forEach(function (other) {
          other.setAttribute("data-open", "false");
          var b = other.querySelector(".rf-faq__q");
          if (b) b.setAttribute("aria-expanded", "false");
        });
        if (!open) {
          item.setAttribute("data-open", "true");
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
  });

  /* scroll-reveal */
  if (!reduce && "IntersectionObserver" in window) {
    var targets = [];
    document.querySelectorAll(".rf-sec, .rf-card, .rf-faq__item").forEach(function (el) {
      if (el.closest("[data-quote-modal]")) return;
      el.setAttribute("data-reveal", "");
      targets.push(el);
    });
    if (targets.length) {
      document.documentElement.classList.add("rf-js");
      var io;
      function revealBatch(list) {
        if (!list.length) return;
        /* op documentvolgorde zetten: een blok mag nooit voor het blok erboven verschijnen */
        list.sort(function (a, b) { return (a.compareDocumentPosition(b) & 4) ? -1 : 1; });
        list.forEach(function (el, i) {
          var wait = Math.min(i, 6) * 60;
          el.style.willChange = "opacity, transform";
          el.style.transitionDelay = wait + "ms";
          el.classList.add("is-visible");
          setTimeout(function () {
            el.classList.add("is-done");
            el.style.transitionDelay = "";
            el.style.willChange = "";
          }, 900 + wait);
          if (io) io.unobserve(el);
        });
      }
      io = new IntersectionObserver(function (entries) {
        var shown = [];
        entries.forEach(function (en) { if (en.isIntersecting) shown.push(en.target); });
        revealBatch(shown);
      }, { rootMargin: "0px 0px -12% 0px", threshold: 0.08 });
      targets.forEach(function (el) { io.observe(el); });
      /* noodklep: alleen blokken die al in beeld staan maar niet zijn aangeslagen */
      setTimeout(function () {
        var stuck = targets.filter(function (el) {
          if (el.classList.contains("is-visible")) return false;
          var r = el.getBoundingClientRect();
          return r.top < window.innerHeight && r.bottom > 0;
        });
        revealBatch(stuck);
      }, 2500);
    }
  }

  /* offerteformulier */
  document.querySelectorAll("[data-quote-form]").forEach(initForm);

  function initForm(form) {
    var TOTAL = 4, step = 1, photos = [], sending = false;
    var TITLES = ["Wat heeft u nodig?", "Uw situatie", "Uw gegevens", "Controleren & versturen"];
    var bar = form.querySelector("[data-quote-bar]");
    var stepnum = form.querySelector("[data-quote-stepnum]");
    var steptitle = form.querySelector("[data-quote-steptitle]");
    var panels = form.querySelectorAll("[data-quote-panel]");
    var next = form.querySelector("[data-quote-next]");
    var prev = form.querySelector("[data-quote-prev]");
    var legal = form.querySelector("[data-quote-legal]");
    var errorBox = form.querySelector("[data-quote-error]");
    var live = form.querySelector("[data-quote-live]");
    var done = form.querySelector("[data-quote-done]");
    var reset = form.querySelector("[data-quote-reset]");
    var summary = form.querySelector("[data-quote-summary]");
    var photoInput = form.querySelector("[data-quote-photos]");
    var photoList = form.querySelector("[data-quote-photo-list]");
    var photoMax = parseInt(form.dataset.photoMax, 10) || 12;
    var momentField = form.querySelector("[data-moment-field]");

    var dateInput = form.querySelector("[data-min-tomorrow]");
    if (dateInput) {
      var d = new Date(); d.setDate(d.getDate() + 1);
      dateInput.min = new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    }

    /* keuzeknoppen */
    form.querySelectorAll("[data-chip-group]").forEach(function (group) {
      var single = group.dataset.chipGroup === "moment";
      group.querySelectorAll(".rf-chip").forEach(function (chip) {
        chip.addEventListener("click", function () {
          var on = chip.getAttribute("aria-pressed") === "true";
          if (single) {
            group.querySelectorAll(".rf-chip").forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
            chip.setAttribute("aria-pressed", "true");
            if (momentField) momentField.style.color = "";
            form.querySelectorAll("[data-moment-field] > span").forEach(function (s) { s.style.color = ""; });
          } else if (chip.dataset.exclusive === "true") {
            group.querySelectorAll(".rf-chip").forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
            chip.setAttribute("aria-pressed", on ? "false" : "true");
          } else {
            chip.setAttribute("aria-pressed", on ? "false" : "true");
            var excl = group.querySelector("[data-exclusive='true']");
            if (excl) excl.setAttribute("aria-pressed", "false");
          }
          syncRevealed();
          clearError();
        });
      });
    });

    function syncRevealed() {
      form.querySelectorAll("[data-reveals]").forEach(function (trigger) {
        var target = form.querySelector("[data-field='" + trigger.dataset.reveals + "']");
        if (!target) return;
        if (trigger.getAttribute("aria-pressed") === "true") target.removeAttribute("hidden");
        else target.setAttribute("hidden", "");
      });
    }

    function picked(groupName) {
      var group = form.querySelector("[data-chip-group='" + groupName + "']");
      if (!group) return [];
      return Array.prototype.slice.call(group.querySelectorAll(".rf-chip[aria-pressed='true']"))
        .map(function (c) { return c.querySelector(".rf-chip__label").textContent.trim(); });
    }
    function val(name) {
      var el = form.querySelector("[name='" + name + "']");
      return el ? el.value : "";
    }

    /* validatiekleur per veld */
    form.addEventListener("input", function (e) { mark(e.target); });
    form.addEventListener("change", function (e) {
      mark(e.target);
      if (e.target.dataset.address !== undefined) lookupAddress();
    });
    form.addEventListener("input", function (e) {
      if (e.target.dataset.address !== undefined) lookupAddress();
    });
    function mark(input) {
      if (!input.name || input.type === "file") return;
      var v = (input.value || "").trim();
      if (!v) { input.removeAttribute("data-valid"); return; }
      var ok = true;
      if (input.name === "email") ok = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(v);
      else if (input.name === "telefoon") ok = v.replace(/[^0-9]/g, "").length >= 10;
      else if (input.name === "postcode") ok = /^[1-9][0-9]{3}\s?[a-z]{2}$/i.test(v);
      else if (input.name === "huisnummer") ok = /^[0-9]+$/.test(v);
      else if (input.name === "naam" || input.name === "straat") ok = v.length >= 2;
      else if (input.name === "datum") ok = checkDate(v);
      input.dataset.valid = String(ok);
    }

    function checkDate(v) {
      var hint = form.querySelector("[data-date-hint]");
      var ok = !dateInput || v >= dateInput.min;
      if (hint) {
        if (ok) hint.setAttribute("hidden", "");
        else {
          hint.textContent = v === todayISO()
            ? "Vandaag kan niet via het formulier. Kies Z.S.M. / SPOED of een datum vanaf morgen."
            : "Kies een datum vanaf morgen.";
          hint.removeAttribute("hidden");
        }
      }
      return ok;
    }

    function todayISO() {
      var t = new Date();
      return new Date(t.getTime() - t.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    }

    /* adres opzoeken (PDOK) */
    var addrTimer, addrLast;
    function lookupAddress() { clearTimeout(addrTimer); addrTimer = setTimeout(runLookup, 450); }
    function runLookup() {
      var pc = (val("postcode") || "").replace(/\s+/g, "").toUpperCase();
      var nr = (val("huisnummer") || "").trim();
      var suffix = (val("toevoeging") || "").replace(/[\s-]/g, "").toLowerCase();
      var hint = form.querySelector("[data-address-hint]");
      var out = form.querySelector("[data-address-result]");
      if (!/^[1-9][0-9]{3}[A-Z]{2}$/.test(pc) || !/^[0-9]+$/.test(nr)) return;
      var key = pc + nr + suffix;
      if (addrLast === key) return;
      addrLast = key;
      showHint(hint, "Adres opzoeken\u2026", false);
      fetch("https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=25&fq=type:adres&fl=straatnaam,woonplaatsnaam,postcode,huisnummer,huisletter,huisnummertoevoeging&q=" + encodeURIComponent(pc + " " + nr))
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var docs = (json.response && json.response.docs) || [];
          var num = parseInt(nr, 10);
          var exact = docs.filter(function (x) {
            return String(x.postcode || "").replace(/\s+/g, "").toUpperCase() === pc && Number(x.huisnummer) === num;
          });
          var sfx = function (x) { return ((x.huisletter || "") + (x.huisnummertoevoeging || "")).replace(/[\s-]/g, "").toLowerCase(); };
          var doc = suffix ? exact.filter(function (x) { return sfx(x) === suffix; })[0]
                           : (exact.filter(function (x) { return !sfx(x); })[0] || exact[0]);
          if (!doc || !doc.straatnaam) {
            if (out) { out.value = ""; out.dataset.valid = "false"; }
            showHint(hint, "Deze combinatie van postcode en huisnummer bestaat niet \u2014 controleer uw invoer of vul straat en plaats zelf in.", true);
            return;
          }
          if (out) {
            out.value = doc.straatnaam + (doc.woonplaatsnaam ? ", " + doc.woonplaatsnaam : "");
            out.dataset.valid = "true";
          }
          showHint(hint, "Automatisch gevonden.", false);
        })
        .catch(function () { showHint(hint, "Adres opzoeken lukte niet \u2014 vul straat en plaats zelf in.", true); });
    }
    function showHint(el, text, isError) {
      if (!el) return;
      el.textContent = text;
      el.style.color = isError ? "#B4232A" : "#0B7A0B";
      el.removeAttribute("hidden");
    }

    /* foto's */
    if (photoInput) photoInput.addEventListener("change", function () {
      Array.prototype.slice.call(photoInput.files || [])
        .filter(function (f) { return f.type.indexOf("image/") === 0; })
        .forEach(function (file) { if (photos.length < photoMax) photos.push(file); });
      photoInput.value = "";
      renderPhotos();
    });
    function renderPhotos() {
      if (!photoList) return;
      photoList.innerHTML = "";
      photos.forEach(function (file, i) {
        var li = document.createElement("li");
        var img = document.createElement("img");
        img.src = URL.createObjectURL(file); img.alt = "";
        var name = document.createElement("span");
        name.textContent = file.name.length > 22 ? file.name.slice(0, 20) + "\u2026" : file.name;
        var del = document.createElement("button");
        del.type = "button"; del.textContent = "\u00D7";
        del.setAttribute("aria-label", "Foto verwijderen");
        del.addEventListener("click", function () {
          URL.revokeObjectURL(img.src);
          photos.splice(i, 1);
          renderPhotos();
        });
        li.appendChild(img); li.appendChild(name); li.appendChild(del);
        photoList.appendChild(li);
      });
    }

    function fail(msg) {
      if (errorBox) { errorBox.textContent = msg; errorBox.removeAttribute("hidden"); }
      return false;
    }
    function clearError() { if (errorBox) errorBox.setAttribute("hidden", ""); }

    function validate() {
      clearError();
      if (step === 1 && picked("dienst").length === 0) return fail("Kies minimaal \u00e9\u00e9n dienst.");
      if (step === 2) {
        var moment = picked("moment")[0];
        if (!moment) {
          var label = form.querySelector("[data-moment-field] > span");
          if (label) label.style.color = "#B4232A";
          return fail("Kies een gewenst moment.");
        }
        if (moment === "Kies een datum") {
          if (!val("datum")) return fail("Kies een datum.");
          if (dateInput && val("datum") < dateInput.min) {
            var di = form.querySelector("[name='datum']");
            if (di) mark(di);
            return fail("Kies een datum vanaf morgen. Moet het vandaag? Kies dan Z.S.M. / SPOED.");
          }
        }
      }
      if (step === 3) {
        if (val("naam").trim().length < 2) return fail("Vul uw naam in.");
        if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(val("email").trim())) return fail("Vul een geldig e-mailadres in.");
        if (val("telefoon").replace(/[^0-9]/g, "").length < 10) return fail("Vul een geldig telefoonnummer in.");
        if (!/^[1-9][0-9]{3}\s?[a-z]{2}$/i.test(val("postcode").trim())) return fail("Vul een geldige postcode in.");
        if (!/^[0-9]+$/.test(val("huisnummer").trim())) return fail("Vul uw huisnummer in.");
      }
      return true;
    }

    function render() {
      panels.forEach(function (p) {
        if (parseInt(p.dataset.quotePanel, 10) === step) p.removeAttribute("hidden");
        else p.setAttribute("hidden", "");
      });
      if (bar) bar.style.width = (step / TOTAL) * 100 + "%";
      if (stepnum) stepnum.textContent = "Stap " + step + " van " + TOTAL;
      if (steptitle) steptitle.textContent = TITLES[step - 1];
      if (prev) { if (step === 1) prev.setAttribute("hidden", ""); else prev.removeAttribute("hidden"); }
      if (legal) { if (step === 3) legal.removeAttribute("hidden"); else legal.setAttribute("hidden", ""); }
      if (next) next.textContent = sending ? "Versturen\u2026" : (step === TOTAL ? "Aanvraag versturen" : "Volgende");
      if (step === TOTAL) buildSummary();
    }

    function moment() {
      var m = picked("moment")[0] || "\u2014";
      if (m === "Kies een datum" && val("datum")) m = val("datum");
      return m;
    }
    function address() {
      return [val("postcode"), [val("huisnummer"), val("toevoeging")].filter(Boolean).join("-"), val("straat")].filter(Boolean).join(" ");
    }
    function buildSummary() {
      if (!summary) return;
      var extra = val("toelichting").trim();
      var diensten = picked("dienst").map(function (d) {
        return d === "Iets anders" && extra ? "Iets anders: " + extra : d;
      }).join(", ");
      var aantal = picked("dienst").length;
      var rows = [
        [aantal === 1 ? "Dienst" : "Diensten", diensten || "\u2014"],
        ["Gewenst moment", moment()],
        ["Omschrijving", val("omschrijving").trim() || "\u2014"],
        ["Foto's", photos.length ? photos.length + (photos.length === 1 ? " foto" : " foto's") : "\u2014"],
        ["Naam", val("naam") || "\u2014"],
        ["E-mail", val("email") || "\u2014"],
        ["Telefoon", val("telefoon") || "\u2014"],
        ["Adres", address() || "\u2014"]
      ];
      summary.innerHTML = "";
      rows.forEach(function (r) {
        var w = document.createElement("div");
        var dt = document.createElement("dt"); dt.textContent = r[0];
        var dd = document.createElement("dd"); dd.textContent = r[1];
        w.appendChild(dt); w.appendChild(dd);
        summary.appendChild(w);
      });
    }

    if (prev) prev.addEventListener("click", function () { if (step > 1) { step--; clearError(); render(); } });
    if (next) next.addEventListener("click", function () {
      if (sending) return;
      if (!validate()) return;
      if (step < TOTAL) { step++; render(); return; }
      send();
    });
    if (reset) reset.addEventListener("click", function () {
      step = 1; photos = []; renderPhotos();
      form.querySelectorAll(".rf-chip").forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
      form.querySelectorAll("input, textarea").forEach(function (el) { el.value = ""; el.removeAttribute("data-valid"); });
      var dh = form.querySelector("[data-date-hint]");
      if (dh) dh.setAttribute("hidden", "");
      syncRevealed();
      if (done) done.setAttribute("hidden", "");
      if (live) live.removeAttribute("hidden");
      clearError();
      render();
    });

    function send() {
      var key = form.dataset.accessKey;
      var payload = {
        Naam: val("naam"), "E-mail": val("email"), Telefoon: val("telefoon"), Adres: address(),
        "Dienst(en)": picked("dienst").join(", "), "Gewenst moment": moment(),
        Omschrijving: val("omschrijving"), Toelichting: val("toelichting"),
        Taal: (window.rfLang && window.rfLang() === "en") ? "Engels (klant bekeek de site in het Engels)" : "Nederlands"
      };
      if (!key) { mailto(payload); finish(); return; }
      sending = true; render();
      prepare(photos)
        .then(function (klaar) {
          return post(key, payload, klaar).catch(function () {
            var alt = Object.assign({}, payload);
            alt["Let op"] = "De klant voegde " + photos.length + " foto('s) toe. Vraag ze per mail op.";
            return post(key, alt, []);
          });
        })
        .then(function () { sending = false; naarApp(payload, photos.length); finish(); })
        .catch(function () {
          /* Mail lukte niet (blokkering, slecht bereik, limiet). Dan minstens de postbus,
             zodat de aanvraag nooit verloren gaat. */
          naarApp(payload, photos.length).then(function () {
            sending = false; finish();
          }, function () {
            sending = false; render();
            fail("Versturen lukte niet. Probeer het opnieuw of bel " + form.dataset.phone + ".");
          });
        });
    }

    var POSTBUS = "https://script.google.com/macros/s/AKfycbwIw8Ga8AEMLHOLo3s7D4lZhiV_IR0grUUAXzD96VM_bzdpLpj0lQjTqBqOcy4cXljS/exec";

    function naarApp(payload, fotoAantal) {
      if (!POSTBUS) return Promise.reject(new Error("geen postbus"));
      try {
        return fetch(POSTBUS, {
          method: "POST",
          mode: "no-cors",
          headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: JSON.stringify({
            naam: payload.Naam || "",
            email: payload["E-mail"] || "",
            telefoon: payload.Telefoon || "",
            adres: payload.Adres || "",
            diensten: payload["Dienst(en)"] || "",
            moment: payload["Gewenst moment"] || "",
            omschrijving: payload.Omschrijving || "",
            toelichting: payload.Toelichting || "",
            taal: payload.Taal || "",
            fotos: fotoAantal || 0
          })
        });
      } catch (err) { return Promise.reject(err); }
    }

    /* Telefoonfoto's zijn vaak 3-5 MB. Verkleinen houdt de upload klein en snel. */
    function shrink(file) {
      return new Promise(function (resolve) {
        if (!file || !file.type || file.type.indexOf("image/") !== 0 || file.size < 500000 || !window.URL || !document.createElement("canvas").toBlob) {
          resolve(file); return;
        }
        var url = URL.createObjectURL(file);
        var img = new Image();
        var done = false;
        function bail() { if (done) return; done = true; try { URL.revokeObjectURL(url); } catch (e) {} resolve(file); }
        setTimeout(bail, 8000);
        img.onerror = bail;
        img.onload = function () {
          if (done) return;
          try {
            var max = 1600;
            var k = Math.min(1, max / Math.max(img.width, img.height));
            var w = Math.max(1, Math.round(img.width * k));
            var h = Math.max(1, Math.round(img.height * k));
            var c = document.createElement("canvas");
            c.width = w; c.height = h;
            c.getContext("2d").drawImage(img, 0, 0, w, h);
            c.toBlob(function (blob) {
              if (done) return;
              done = true;
              try { URL.revokeObjectURL(url); } catch (e) {}
              if (!blob || blob.size >= file.size) { resolve(file); return; }
              var naam = (file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
              try { resolve(new File([blob], naam, { type: "image/jpeg" })); }
              catch (e) { blob.naam = naam; resolve(blob); }
            }, "image/jpeg", 0.82);
          } catch (e) { bail(); }
        };
        img.src = url;
      });
    }

    function prepare(files) {
      if (!files.length || !window.Promise) return Promise.resolve(files);
      return Promise.all(files.map(shrink)).catch(function () { return files; });
    }

    function post(key, payload, files) {
      var fd = new FormData();
      fd.append("access_key", key);
      fd.append("subject", (payload["Gewenst moment"] === "Z.S.M. / SPOED" ? "SPOED \u2014 offerteaanvraag" : "Offerteaanvraag") + " \u2014 " + (payload.Naam || "website"));
      fd.append("from_name", "Reyform website");
      if (payload["E-mail"]) {
        fd.append("replyto", payload["E-mail"]);
        /* Web3Forms gebruikt het veld "email" voor de bevestigingsmail aan de klant. */
        fd.append("email", payload["E-mail"]);
      }
      Object.keys(payload).forEach(function (k) { if (payload[k]) fd.append(k, payload[k]); });
      files.forEach(function (file, i) { fd.append("Foto " + (i + 1), file, file.name || file.naam || ("foto-" + (i + 1) + ".jpg")); });
      var opts = { method: "POST", body: fd };
      var kill = null;
      if (window.AbortController) {
        var ac = new AbortController();
        opts.signal = ac.signal;
        kill = setTimeout(function () { try { ac.abort(); } catch (e) {} }, files.length ? 60000 : 20000);
      }
      return fetch("https://api.web3forms.com/submit", opts).then(function (res) {
        if (kill) clearTimeout(kill);
        return res.json().catch(function () { return {}; }).then(function (json) {
          if (!res.ok || json.success === false) throw new Error("mislukt");
          return json;
        });
      }, function (err) { if (kill) clearTimeout(kill); throw err; });
    }

    function mailto(payload) {
      var body = Object.keys(payload).map(function (k) { return k + ": " + (payload[k] || "-"); }).join("\n");
      window.location.href = "mailto:" + form.dataset.email
        + "?subject=" + encodeURIComponent("Offerteaanvraag " + (payload.Naam || "website"))
        + "&body=" + encodeURIComponent(body);
    }

    function confetti() {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return { stop: function () {} };
      var wrap = document.createElement("div");
      wrap.className = "rf-confetti";
      wrap.setAttribute("aria-hidden", "true");
      document.body.appendChild(wrap);
      var colors = ["#00B900", "#0090E3", "#37C6FF", "#00D400", "#FFC53D", "#fff"];
      var timer = null, alive = true;

      function drop(delayMax) {
        var p = document.createElement("i");
        var dur = 2.4 + Math.random() * 2;
        p.style.left = (Math.random() * 100) + "vw";
        p.style.background = colors[(Math.random() * colors.length) | 0];
        p.style.setProperty("--dx", (Math.random() * 220 - 110) + "px");
        p.style.setProperty("--rot", (Math.random() * 1080 - 540) + "deg");
        p.style.animationDuration = dur + "s";
        p.style.animationDelay = (Math.random() * (delayMax || 0)) + "s";
        p.style.opacity = 0.75 + Math.random() * 0.25;
        if (Math.random() < 0.35) { p.style.width = "7px"; p.style.height = "7px"; p.style.borderRadius = "999px"; }
        p.addEventListener("animationend", function () { if (p.parentNode) p.parentNode.removeChild(p); });
        wrap.appendChild(p);
      }

      for (var i = 0; i < 60; i++) drop(0.6);
      timer = setInterval(function () { if (alive) for (var k = 0; k < 6; k++) drop(0.5); }, 420);

      return {
        stop: function () {
          alive = false;
          if (timer) clearInterval(timer);
          /* geen nieuwe stukjes meer; wat valt, valt netjes uit */
          setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 5600);
        }
      };
    }

    function cheer() {
      if (document.querySelector(".rf-cheer")) return;
      var title = done ? done.querySelector("h3") : null;
      var text = done ? done.querySelector(":scope > p") : null;
      var veil = document.createElement("div");
      veil.className = "rf-cheer";
      veil.setAttribute("role", "dialog");
      veil.setAttribute("aria-modal", "true");
      veil.innerHTML = '<div class="rf-cheer__card">'
        + '<button type="button" class="rf-cheer__close" aria-label="Sluiten"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"></path></svg></button>'
        + '<div class="rf-cheer__ring"><svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.6 4.5L19 7"></path></svg></div>'
        + '<h3></h3><p></p>'
        + '<button type="button" class="rf-btn rf-btn--blue rf-btn--sm" data-cheer-reset>Nieuwe aanvraag</button>'
        + "</div>";
      veil.querySelector("h3").textContent = title ? title.textContent : "Bedankt voor uw aanvraag";
      veil.querySelector("p").innerHTML = text ? text.innerHTML : "";
      document.body.appendChild(veil);
      var snow = confetti();
      var card = veil.querySelector(".rf-cheer__card");
      var btn = veil.querySelector("[data-cheer-reset]");
      if (btn && btn.focus) btn.focus({ preventScroll: true });
      function close(alsoReset) {
        if (snow) snow.stop();
        if (veil.parentNode) veil.parentNode.removeChild(veil);
        document.removeEventListener("keydown", onKey);
        if (alsoReset && reset) reset.click();
      }
      function onKey(e) { if (e.key === "Escape") close(false); }
      document.addEventListener("keydown", onKey);
      veil.addEventListener("click", function (e) { if (!card.contains(e.target)) close(false); });
      veil.querySelector(".rf-cheer__close").addEventListener("click", function () { close(false); });
      if (btn) btn.addEventListener("click", function () { close(true); });
    }

    function finish() {
      clearError();
      if (live) live.setAttribute("hidden", "");
      if (done) done.removeAttribute("hidden");
      cheer();
    }

    syncRevealed();
    render();
  }
})();
